// Create an internal cache using a Map
const cache = new Map();
const preloadedImages = new Set(); // Track preloaded images

const measureElementHeight = function (el) {
  // Clone the element
  const clone = el.cloneNode(true);

  // Get the parent of the original element
  const parent = el.parentNode;

  // Get computed styles of the original element
  const elStyle = window.getComputedStyle(el);
  const elMaxHeight = elStyle.maxHeight.replace("px", "").replace("%", "");

  // If the element is not hidden, just return its normal height
  if (elStyle.display !== "none" && elMaxHeight !== "0") {
    return el.offsetHeight;
  }

  // Apply styles to make the clone measurable while hidden
  clone.style.position = "absolute";
  clone.style.visibility = "hidden";
  clone.style.top = "0"; // Place it at the top of the parent
  clone.style.left = "0"; // Place it at the left of the parent
  clone.style.zIndex = "-1"; // Prevent overlapping visible content
  clone.style.display = "block";
  clone.style.height = "auto"; // Ensure it calculates full height
  clone.style.width = elStyle.width; // Match the width of the original element
  clone.style.boxSizing = elStyle.boxSizing; // Preserve box-sizing for accuracy
  clone.style.padding = elStyle.padding; // Copy padding for accurate height
  clone.style.border = elStyle.border; // Copy borders for accurate height

  // Append the clone to the same parent as the original
  parent?.appendChild(clone);

  // Measure the height
  const wantedHeight = Math.max(
    clone.scrollHeight,
    clone.offsetHeight,
    clone.clientHeight
  );

  // Remove the clone from the DOM
  parent?.removeChild(clone);

  // Return the measured height
  return wantedHeight;
};

// Function to fetch data for a specific variant and store it in cache
const fetchVariantData = async (variantId, baseUrl, sectionId) => {
  if (cache.has(variantId)) {
    return cache.get(variantId);
  }

  const url = `${baseUrl}?variant=${variantId}&section_id=${sectionId}`;

  return fetch(url)
    .then((response) => response.text())
    .then((data) => {
      cache.set(variantId, data);
      return data; // Return the fetched data
    })
    .catch((error) => {
      console.error("Error fetching data for variant", variantId, error);
    });
};

// Function to load and fetch data for all variants
const loadAllVariantsData = async (variantIds, baseUrl, sectionId) => {
  const fetchPromises = variantIds.map((variantId) =>
    fetchVariantData(variantId, baseUrl, sectionId)
  );
  return Promise.all(fetchPromises);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const galleryImageLoad = document.querySelector(`[id^="Slider-Gallery"]`);
    if (galleryImageLoad) {
      galleryImageLoad.classList.remove("d-none");
    }
  }, 500);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  // commented out for testing
  // if (summary.nextElementSibling.getAttribute("id")) {
  //   summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  // }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.isClosing = false; // Add a flag to prevent immediate reopening

    // Close button event
    const closeButton = this.querySelector('[id^="ModalClose-"]');
    if (closeButton) {
      closeButton.addEventListener("click", (event) => {
        this.close(event);
      });
    }

    // ESC key event
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        this.close(event);
      }
    });

    // Pointer or click events
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" || event.pointerType === "touch") {
          //right click on the mouse is 2
          if (event.button !== 2) {
            this.close(event);
          }
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) {
          this.close(event);
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  showModalOpener() {
    const parent = this.openedBy.closest(".product__modal-opener");
    if (parent) {
      parent.style.display = "block";
    }
  }

  hideModalOpener() {
    const parent = this.openedBy.closest(".product__modal-opener");
    if (parent) {
      parent.style.display = "none";
    }
  }

  show(opener) {
    this.openedBy = opener;
    if (this.isClosing) return; // Prevent reopening during cooldown
    this.hideModalOpener(); // Hide the opener element

    if (opener) {
      const mediaId = opener.getAttribute("data-media-id");
      const img = document.querySelector(`img.product-media-image[data-media-id="${mediaId}"]`);
      if (img) {
        if (img?.dataset?.src && img?.dataset?.srcset) {
          img.classList.add("hidden")

          const spinner = document.createElement("div");
          spinner.className = "spinner-border";
          spinner.style.height = "50px"
          spinner.style.width = "50px"
          img.parentNode.insertBefore(spinner, img);
          const src = img.dataset.src;
          const srcset = img.dataset.srcset;

          delete img.dataset.src;
          delete img.dataset.srcset;

          img.onload = () => {
            img.classList.remove("hidden")
            spinner.remove()
          };
          img.onerror = () => spinner.remove();

          img.src = src;
          img.srcset = srcset;
        }
      }
    }

    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    const modalContent = this.querySelector(".product-media-modal__content");
    if (modalContent) {
      const middle = modalContent.scrollHeight / 2 - modalContent.clientHeight / 2;
      modalContent.scrollTop = middle;
    }
    window.pauseAllMedia();
  }

  close(event) {
    if (this.isClosing) return; // Prevent duplicate close actions
    this.isClosing = true; // Set the closing flag
    this.showModalOpener(); // Show the opener element

    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    // Reset the flag after a short delay
    setTimeout(() => {
      this.isClosing = false;
    }, 0); // Adjust the cooldown period as needed
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    const image = this.querySelector("img");

    if (!button) return;
    button.addEventListener("click", (event) => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });

    if (!image) return;
    image.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    const sliderItems1 = this.querySelectorAll('[id^="1-Slide-template"]');
    const sliderItems2 = this.querySelectorAll('[id^="Slide"]');
    const sliderItemsArray1 = Array.from(sliderItems1);
    const sliderItemsArray2 = Array.from(sliderItems2);
    const allSliderItems = [...sliderItemsArray1, ...sliderItemsArray2];
    this.sliderItems = allSliderItems;
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = window.TotalPageMedia?.length;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.currentPage === 1 && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }
    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = parseInt(event.currentTarget.dataset.step, 10) || 1;
    if (event.currentTarget.name === "next") {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    } else if (event.currentTarget.name === "previous") {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }

    const newPosition = (this.currentPage - 1) * this.sliderItemOffset;
    this.setSlidePosition(newPosition);
    this.initPages();
  }

  setSlidePosition(position) {
    position = Math.max(
      0,
      Math.min(position, this.slider.scrollWidth - this.slider.clientWidth)
    );
    this.slider.scrollLeft = position;
    this.update();
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.reload();
  }

  reload() {
    this.renderMedia();
    this.initTariffUpdater();
    this.fetchVariants();
    this.updateVariantStatuses();
  }
  onVariantChange() {
    this.updateOptions();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateMasterId();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      console.log("variant change");
      this.updateMedia();
      this.initTariffUpdater();
      this.openModal();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      // Get all radio inputs in the fieldset
      const radios = Array.from(fieldset.querySelectorAll("input"));

      // Find the currently checked radio button
      const checkedRadio = radios.find((radio) => radio.checked);

      // Check if the checked input exists and has the 'disabled' class
      if (checkedRadio && checkedRadio.classList.contains("disabled")) {
        // If a checked input is disabled, remove 'checked' from all radios in the fieldset
        radios.forEach((radio) => {
          radio.checked = false;
        });

        // Find the first non-disabled radio button
        const firstNonDisabledRadio = radios.find(
          (radio) => !radio.classList.contains("disabled")
        );

        // If a non-disabled radio is found, check it and return its value
        if (firstNonDisabledRadio) {
          firstNonDisabledRadio.checked = true;
          return firstNonDisabledRadio.value;
        }

        // If no non-disabled radio is found, return null
        return null;
      }

      // If no checked input is disabled, return the value of the checked radio (if it exists)
      return checkedRadio ? checkedRadio.value : null;
    });
  }



  updateMasterId(options = this.options) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return options[index] === option;
        })
        .includes(false);
    });
    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return options[0] === variant.options[0];
      });
    }
  }

  openModal() {
    const modalContent = document.querySelector(
      `#Modal-${this.dataset.section} .product-media-modal__content`
    );
    const variantValues = this.currentVariant.options;
  }

  initTariffUpdater() {
    const tariffDiv = document.querySelector("#tariff-amount");
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!tariffDiv || !quantityInput) return;

    const formatCurrency = (value) => {
      return "$" + Number(value).toFixed(2);
    };

    const updateTariff = () => {
      const tariffDiv = document.getElementById("tariff-amount");
      const quantityInput = document.querySelector('input[name="quantity"]');
      const baseTariff = parseFloat(tariffDiv.dataset.baseTariff || "0");
      const quantity = parseInt(quantityInput.value || "1");
      const total = baseTariff * quantity;
      tariffDiv.textContent = formatCurrency(total);
    };

    quantityInput.addEventListener("input", updateTariff);
    quantityInput.addEventListener("change", updateTariff);

    const observer = new MutationObserver(updateTariff);
    observer.observe(quantityInput, { attributes: true });

    updateTariff();
  }

  updateMedia() {
    // Selected Variants Code
    const variantValues = this.currentVariant.options;
    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    mediaGalleries.forEach((mediaGallery) => {
      const mediaItems = mediaGallery.querySelectorAll("[data-media-id]");
      // Set active media for the current variant
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );

    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );

      if (newMediaModal) {
        modalContent.prepend(newMediaModal);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    console.log("variant status update");
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked")?.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const labels = [...option.querySelectorAll("label")];

      // Check if previousOptionSelected exists before accessing .value
      const previousChecked =
        inputWrappers[index - 1].querySelector(":checked");
      const previousOptionSelected = previousChecked
        ? previousChecked.value
        : null;

      if (!previousOptionSelected) {
        // Skip this iteration if there's no selected value in the previous option
        return;
      }

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            // variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);

      const availableOption =
        availableOptionInputsValue.length > 0
          ? availableOptionInputsValue
          : selectedOptionOneVariants
            // .filter((variant) => variant.available)
            .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(
        optionInputs,
        availableOption,
        labels,
        availableOption
      );
    });
  }

  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions,
    labels,
    availableOptionInputsValue
  ) {
    if (availableOptionInputsValue.length < 1) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          input.checked = true;
        } else {
          input.checked = false;
        }
      });
    }
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }



  renderProductInfo() {
    console.time("Total Render Time");
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const baseUrl = this.dataset.url;
    fetchVariantData(requestedVariantId, baseUrl, sectionId).then(
      (responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        const html = new DOMParser().parseFromString(responseText, "text/html");

        if (this.currentVariant.id !== requestedVariantId) return;
        const mediaGallery = document.querySelector(
          `[id^="MediaGallery-${this.dataset.section}"]`
        );
        if (
          mediaGallery.hasAttribute("image-grouping-enabled") ||
          mediaGallery.hasAttribute("image-grouping-disable")
        ) {
          mediaGallery.querySelectorAll("[data-image-group]").forEach((el) => {
            const mediaAlt = el.getAttribute("data-media-alt");
            const trimmedMediaAlt = mediaAlt
              .split(",")
              .map((item) => item.trim());
            const matchFound = window.skus.some((sku) =>
              trimmedMediaAlt.includes(sku)
            );

            if (matchFound) {
              el.classList.add("hide-media");
            }
          });

          const skuSource2 = html.getElementById("skuValue");
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = skuSource2.innerHTML;
          const skuValue = tempDiv.lastChild.nodeValue.trim();
          mediaGallery.querySelectorAll("[data-image-group]").forEach((el) => {
            const mediaAlts = el
              .getAttribute("data-media-alt")
              .split(",")
              .map((alt) => alt.trim());
            if (mediaAlts.includes(skuValue)) {
              el.classList.remove("hide-media");
            }
          });
        }

        const metafieldSourceShipping = html.getElementById(
          `product__shipping-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const metafieldSourcealtVendorLink = html.getElementById(
          `product__shipping-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const metafieldDestinationShipping = document.getElementById(
          `product__shipping-${this.dataset.section}`
        );
        if (metafieldSourceShipping && metafieldDestinationShipping) {
          metafieldDestinationShipping.innerHTML =
            metafieldSourceShipping.innerHTML;
          metafieldDestinationShipping.href = metafieldSourcealtVendorLink;
        }

        const metafieldSourcePrdctLabel = html.getElementById(
          `product__label-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const metafieldDestinationPrdctLabel = document.getElementById(
          `product__label-${this.dataset.section}`
        );
        if (metafieldSourcePrdctLabel) {
          const innerText = metafieldSourcePrdctLabel.innerText.trim();
        }
        if (metafieldSourcePrdctLabel && metafieldDestinationPrdctLabel) {
          metafieldDestinationPrdctLabel.innerText =
            metafieldSourcePrdctLabel.innerText;
        }

        if (
          (!metafieldSourcePrdctLabel ||
            metafieldSourcePrdctLabel.innerText === "") &&
          (!metafieldDestinationPrdctLabel ||
            metafieldDestinationPrdctLabel.innerText === "")
        ) {
          if (metafieldDestinationPrdctLabel) {
            metafieldDestinationPrdctLabel.innerText = "";
          }
        }
        updateProductBadge();

        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const skuDestination = document.querySelector(
          `[id^="Sku-${this.dataset.section}"]`
        );
        if (skuSource) {
          if (skuDestination.classList.contains("hidden")) {
            skuDestination.classList.remove("hidden");
          }
        }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (skuSource && destination) {
          destination.innerHTML = source.innerHTML;
        }
        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        //For Sold out products

        const productData = html.getElementById("current-product");
        const available = productData.getAttribute("data-set") === "true";
        checkSoldOut(available);
        onVariantChangeAndOnLoad(html);
        updateAccordionContent(html, sectionId);
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
        console.timeEnd("Total Render Time");
      }
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  renderMedia() {
    const url = window.location.href;
    const urlObj = new URL(url);
    const requestedVariantId = urlObj.searchParams.get("variant");
    const currentvariantid = this.getVariantData().map((variant) => {
      return variant;
    });
    const cuurentid = requestedVariantId
      ? requestedVariantId
      : currentvariantid[0].id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const baseUrl = this.dataset.url;
    fetchVariantData(cuurentid, baseUrl, sectionId).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const mediaGallery = document.querySelector(
        `[id^="MediaGallery-${this.dataset.section}"]`
      );
      if (
        mediaGallery.hasAttribute("image-grouping-enabled") ||
        mediaGallery.hasAttribute("image-grouping-disable")
      ) {
        mediaGallery.querySelectorAll("[data-image-group]").forEach((el) => {
          const mediaAlt = el.getAttribute("data-media-alt");

          const trimmedMediaAlt = mediaAlt
            .split(",")
            .map((item) => item.trim());
          const matchFound = window.skus.some((sku) =>
            trimmedMediaAlt.includes(sku)
          );
          if (matchFound) {
            el.classList.add("hide-media");
          }
        });

        const metafieldSourceShipping = html.getElementById(
          `product__shipping-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );

        const metafieldDestinationShipping = document.getElementById(
          `product__shipping-${this.dataset.section}`
        );
        if (metafieldSourceShipping && metafieldDestinationShipping) {
          metafieldDestinationShipping.innerHTML =
            metafieldSourceShipping.innerHTML;
        }

        const skuSource2 = html.getElementById("skuValue");
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = skuSource2.innerHTML;
        const skuValue = tempDiv.lastChild.nodeValue.trim();

        mediaGallery.querySelectorAll("[data-image-group]").forEach((el) => {
          const mediaAlts = el
            .getAttribute("data-media-alt")
            .split(",")
            .map((alt) => alt.trim());
          if (mediaAlts.includes(skuValue)) {
            el.classList.remove("hide-media");
          }
        });
      }

      updateAccordionContent(html, sectionId);

      const metafieldSourcePrdctLabel = html.getElementById(
        `product__label-${this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
        }`
      );

      const metafieldDestinationPrdctLabel = document.getElementById(
        `product__label-${this.dataset.section}`
      );
      if (metafieldSourcePrdctLabel && metafieldDestinationPrdctLabel) {
        metafieldDestinationPrdctLabel.innerText =
          metafieldSourcePrdctLabel?.innerText;
      }

      if (
        (!metafieldSourcePrdctLabel ||
          metafieldSourcePrdctLabel.innerText === "") &&
        (!metafieldDestinationPrdctLabel ||
          metafieldDestinationPrdctLabel.innerText === "")
      ) {
        if (metafieldDestinationPrdctLabel) {
          metafieldDestinationPrdctLabel.innerText = "";
        }
      }

      updateProductBadge();
    });
  }

  fetchVariants() {
    document.addEventListener("readystatechange", () => {
      if (document.readyState === "complete") {
        const variants = this.getVariantData().map((each) => each.id);
        const baseUrl = this.dataset.url;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        loadAllVariantsData(variants, baseUrl, sectionId).then(() => {
          const pickUpAvailability = document.querySelector("pickup-availability");
          if (!pickUpAvailability) return;
          pickUpAvailability.setAllVariants(cache);
        });
      }
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions,
    labels,
    availableOptionInputsValue
  ) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
    this.updateOptions(listOfOptions);
  }

  updateOptions(listOfOptions) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      // Get all radio inputs in the fieldset
      const radios = Array.from(fieldset.querySelectorAll("input"));

      // Find the currently checked radio button
      const checkedRadio = radios.find((radio) => radio.checked);

      // Check if the checked input exists and has the 'disabled' class
      if (checkedRadio && checkedRadio.classList.contains("disabled")) {
        // If a checked input is disabled, remove 'checked' from all radios in the fieldset
        radios.forEach((radio) => {
          radio.checked = false;
        });

        // Find the first non-disabled radio button
        const firstNonDisabledRadio = radios.find(
          (radio) => !radio.classList.contains("disabled")
        );

        // If a non-disabled radio is found, check it and return its value
        if (firstNonDisabledRadio) {
          firstNonDisabledRadio.checked = true;
          return firstNonDisabledRadio.value;
        }

        // If no non-disabled radio is found, return null
        return null;
      }

      // If no checked input is disabled, return the value of the checked radio (if it exists)
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

const loadImages = (imgs) => {
  let images = document.querySelectorAll("img.image-magnify-lightbox");
  let modalImages = document.querySelectorAll("img.product-media-image");

  if (imgs) {
    images = imgs;
    modalImages = []
  }
  const visibleImages = [];
  const hiddenImages = [];

  images.forEach((img) => {
    const rect = img.getBoundingClientRect();
    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
      visibleImages.push(img); // Image is in the viewport
    } else {
      hiddenImages.push(img); // Image is not in the viewport
    }
  });


  const sortedImages = [...visibleImages, ...hiddenImages, ...modalImages]; // Prioritize visible images

  // Batch process images in chunks of 10
  batchLoadImages(sortedImages, 10);
};

const batchLoadImages = (images, batchSize) => {
  let index = 0;

  function loadNextBatch() {
    const batch = images.slice(index, index + batchSize);
    if (batch.length === 0) return; // Stop when all images are loaded

    // Wait for the current batch to complete before loading the next
    Promise.all(batch.map(loadImage)).then(() => {
      index += batchSize;
      setTimeout(loadNextBatch, 500); // Wait a bit before next batch
    });
  }

  loadNextBatch();
};

const loadImage = (img) => {
  /**
   * Calculates the effective width of an image based on its `sizes` attribute.
   * @param {string} sizes - The `sizes` attribute of the image.
   * @returns {number} - The effective width in pixels.
   */
  function calculateEffectiveWidth(sizes) {
    const viewportWidth = window.innerWidth;
    const sizeList = sizes.split(", ");

    for (const size of sizeList) {
      const [condition, width] = size.split(" ");
      if (!condition || condition === "(max-width: 100%)") {
        return parseWidth(width);
      }

      if (window.matchMedia(condition).matches) {
        return parseWidth(width);
      }
    }

    return viewportWidth; // Default to viewport width
  }

  /**
   * Parses a width value (e.g., "100px", "50vw", "calc(...)") into pixels.
   * @param {string} width - The width value to parse.
   * @returns {number} - The width in pixels.
   */
  function parseWidth(width) {
    // Create a temporary element to compute the width
    const testEl = document.createElement("div");
    testEl.style.width = width;
    testEl.style.position = "absolute"; // Ensure it doesn't affect layout
    document.body.appendChild(testEl);

    // Force layout calculation
    const computedWidth = getComputedStyle(testEl).width;

    // Clean up
    document.body.removeChild(testEl);

    return parseFloat(computedWidth) || 0;
  }

  return new Promise((resolve) => {
    let imageUrl = img.src || img.dataset.src;
    const imageSrcset = img.srcset || img.dataset.srcset

    // If the image has a `srcset`, use the most appropriate URL based on `sizes`
    if (imageSrcset && img.sizes) {
      const sources = imageSrcset.split(", ").map((src) => {
        const [url, width] = src.split(" ");
        return { url, width: parseInt(width) };
      });

      // Calculate the effective width based on `sizes`
      const effectiveWidth = calculateEffectiveWidth(img.sizes);

      // Find the best matching source based on the effective width
      const bestSource = sources.reduce((best, source) => {
        if (
          !best ||
          Math.abs(source.width - effectiveWidth) <
          Math.abs(best.width - effectiveWidth)
        ) {
          return source;
        }
        return best;
      });

      if (bestSource) {
        imageUrl = bestSource.url;
      }
    }

    // Preload the image
    const image = new Image();
    image.sizes = img.sizes;
    image.srcset = imageSrcset;
    image.width = img.width;
    image.src = imageUrl;

    if (preloadedImages.has(image.currentSrc)) return resolve();

    image.onload = () => {
      console.log(`✅ Image loaded: ${image.currentSrc}`);
      preloadedImages.add(image.currentSrc);
      delete img.dataset.src;
      delete img.dataset.srcset;

      img.src = image.currentSrc;
      img.srcset = image.srcset;
      resolve()
    };

    image.onerror = () => {
      console.error(`❌ Failed to load image: ${imageUrl}`);
      resolve()
    };
  })
}



//Hide Shipping Availability if there is not data init
const checkAvailability = () => {
  const availabilities = document.querySelectorAll(
    '[id^="product__shipping-"]'
  );
  availabilities.forEach((availability) => {
    if (availability.innerHTML.trim() || availability.innerText.trim()) {
      availability.style.setProperty("visibility", "visible", "important");
    } else {
      availability.style.setProperty("display", "none", "important");
    }
  });
};

//update product badge color
// const isComingSoonBadge = () => {
//   const badge = document.querySelector(".labelBadge");
//   const text = badge?.innerText?.trim().toLowerCase();
//   return text === "coming soon";
// };
const getCurrentBadgeText = () => {
  const badge = document.querySelector(".labelBadge");
  return badge?.innerText?.trim().toLowerCase() || "";
};



const updateProductBadge = () => {
  const prdctBadgeLabels = document.querySelectorAll(".labelBadge");
  const classesToRemove = [
    "bg-green-3", "bg-gray-3", "bg-blue-3", "bg-black",
    "bg-yellow-3", "border-green-4", "bg-red-3", "text-black",
    "text-white", "text-green-4", "border-2", "bg-blue-5", "invisible", "d-none"
  ];

  const badgeColors = [
    { badgeText: "no longer available", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "sale", bg: "bg-red-3", text: "text-black" },
    { badgeText: "new", bg: "bg-green-3", text: "text-black" },
    { badgeText: "sold out", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "refurbished", bg: "bg-blue-3", text: "text-white" },
    { badgeText: "certified refurbished", bg: "bg-blue-3", text: "text-white" },
    { badgeText: "best seller", bg: "bg-yellow-3", text: "text-black" },
    { badgeText: "out of stock", bg: "bg-gray-3", text: "text-black" },
    { badgeText: "b-stock", bg: "bg-blue-5", text: "text-white" },
    { badgeText: "pre-order", bg: "border-green-4", text: "text-green-4", border: "border-2" },
    { badgeText: "coming soon", bg: "bg-black", text: "text-white" },
  ];

  prdctBadgeLabels.forEach((label) => {
    if (!label) return;
    label.classList.remove(...classesToRemove);
    const text = label?.innerText?.trim().toLowerCase();
    if (!text) {
      label.classList.add("d-none");
      return;
    }

    badgeColors.forEach((color) => {
      if (text === color.badgeText) {
        label.classList.add(color.bg, color.text);
        if (color.border) label.classList.add(color.border);
      }
    });
  });

  checkSoldOut();
};

const checkSoldOut = (available) => {
  const badgeText = getCurrentBadgeText();

  const isComingSoon = badgeText === "coming soon";
  const isSoldOutBadge = badgeText === "sold out";

  if (available === undefined) {
    const productData = document.getElementById("current-product");
    if (productData) {
      available = productData.getAttribute("data-set") === "true";
    }
  }

  const contactSales = document.getElementById("contact-us");
  if (contactSales) available = false;

  const shouldHide = !available || isComingSoon || isSoldOutBadge;


  const elementsToToggle = [
    { selector: '[class^="quantity-template"]', name: "quantity" },
    { selector: '[id^="price-"]', name: "price" },
    { selector: "#sold-out-badge", name: "badge" },
    { selector: '[id^="ProductSubmitButton"]', name: "add to cart" },
    { selector: '[id^="product__shipping"]', name: "soldout" },
    { selector: "#shop-pay", name: "shop pay" }
  ];

  document.querySelectorAll(".accordion").forEach((accordion) => {
    const title = accordion.querySelector(".accordion__title")?.innerText?.toLowerCase();
    if (title?.includes("shipping") && title.includes("returns")) {
      elementsToToggle.push({ selector: `#${accordion.id}`, name: "shipping accordion" });
    }
  });

  elementsToToggle.forEach(({ selector, name }) => {
    const element = document.querySelector(selector);
    if (!element) return;

    if (shouldHide) {
      if (name === "badge") {
        element.classList.remove("hidden");
      } else if (name === "add to cart") {
        element.classList.add("d-none");
      } else if (name === "soldout") {
        element.style.setProperty("visibility", "hidden", "important");
        element.style.setProperty("display", "none", "important");
      } else {
        element.classList.add("hidden");
      }
    } else {
      if (name === "badge") {
        element.classList.add("hidden");
      } else if (name === "add to cart") {
        element.classList.remove("d-none");
      } else if (name === "soldout") {
        element.style.setProperty("visibility", "visible", "important");
        element.style.setProperty("display", "", "important");
      } else if (name === "quantity") {
        const section = document.getElementById("ctrl-5-license-section");
        const hasLicense = section?.dataset?.license;
        if (hasLicense === "false" || hasLicense === false) {
          element.classList.remove("hidden");
        }
      } else {
        element.classList.remove("hidden");
      }
    }
  });
};



document.addEventListener("variant:change", (event) => {
  const variant = event.detail.variant;
  if (!variant) return;

  const variantLabel = variant.metafields?.global?.productLabelV || "";
  const label = variantLabel || window.productLabelGlobal || "";

  let available = variant.available;

  if (typeof variant.inventory_quantity !== "undefined") {
    const qty = variant.inventory_quantity;
    const policy = variant.inventory_policy;

    if (qty <= 0 && policy !== "continue") {
      available = false;
    }
  }

  updateProductBadge();
  // ------- UPDATE ACCORDION CONTENT ON VARIANT CHANGE -------
fetch(`${window.location.pathname}?variant=${variant.id}&section_id=main-product`)
  .then(res => res.text())
  .then(htmlText => {
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlText, "text/html");

    // This sectionId must match your Liquid accordion block section ID
    const sectionId = document
      .querySelector(".product-accordion")
      ?.dataset?.sectionId;

    if (sectionId) {
      updateAccordionContent(html, sectionId);
    }
  })
  .catch(err => console.error("Accordion update error:", err));


  setTimeout(() => {
    checkSoldOut(available);
  }, 150);
});




document.querySelectorAll('select[name="id"], [type="radio"][name="id"]').forEach((input) => {
  input.addEventListener('change', () => {
    setTimeout(updateProductBadge, 100);
  });
});

document.addEventListener("DOMContentLoaded", updateProductBadge);

const toggleCtrl5License = (hasLicense = false) => {
  const section = document.getElementById("ctrl-5-license-section");
  const serialNumber = document.getElementById("serial-number");
  const serialError = document.getElementById("serial-error");
  const serialNumberHidden = document.getElementById("serial-number-hidden");
  const isSerialNumber = document.getElementById("is-serial-number");
  const quantity = document.querySelector('[id^="Quantity-Form-"]');

  if (
    !section ||
    !serialNumber ||
    !serialNumberHidden ||
    !serialError ||
    !isSerialNumber ||
    !quantity
  )
    return;
  section.classList.remove("hidden");
  serialNumberHidden.classList.remove("hidden");
  isSerialNumber.classList.remove("hidden");
  serialNumber.value = "";
  serialNumberHidden.value = "";
  serialError.textContent = "";
  serialNumber.style.borderColor = "#000";
  isSerialNumber.value = hasLicense;

  if (hasLicense == "true" || hasLicense == true) {
    if (!quantity.classList.contains("hidden")) {
      quantity.classList.add("hidden");
    }
  }
  if (hasLicense == "false" || hasLicense == false) {
    section.classList.add("hidden");
    serialNumberHidden.classList.add("hidden");
    isSerialNumber.classList.add("hidden");
    quantity.classList.remove("hidden");
  }
};

const onVariantChangeAndOnLoad = (Html, onLoad = false) => {
  if (!Html) {
    Html = document;
  }

  const subheading = Html.querySelector(".product-subheading");
  const headingContainer = Html.querySelector("div.product__title");
  const section = Html.getElementById("ctrl-5-license-section");
  const hasLicense = section?.dataset?.license;

  if (subheading && headingContainer) {
    const clone = subheading.cloneNode(true);
    headingContainer.append(clone);
    subheading.remove();
  } else {
    if (!subheading)
      console.warn("No element found with the class 'product-subheading'.");
    if (!headingContainer)
      console.warn("No element found with the class 'product__title'.");
  }

  if (!onLoad) {
    toggleCtrl5License(hasLicense);
  }
};

const updateAccordionContent = (html, sectionId) => {
  const accordionIds = [
    `.product-accordion-body-Product-Overview-${sectionId}`,
    `.product-accordion-body-In-the-Box-${sectionId}`,
    `.product-accordion-body-Shipping-\\&-Returns-${sectionId}`,
    `.product-accordion-body-B-Stock-Terms-${sectionId}`,
    `.product-accordion-body-Certified-Refurbished-Terms-${sectionId}`,
  ];

  const isDesktop = window.innerWidth > 768;
  const rightSection = document.querySelector(".product__info-container.product__column-sticky");
  const leftSection = document.querySelector(".slider-mobile-gutter");
  const isSticky = isDesktop && leftSection && rightSection && leftSection.scrollHeight >= rightSection.scrollHeight;

  // Find all currently active accordions and calculate heights BEFORE content change
  const activeAccordions = document.querySelectorAll('.product-accordion-item.active');
  const newActiveAccordions = html.querySelectorAll('.product-accordion-item.active');
  let oldTotalHeight = 0;
  let newTotalHeight = 0;

  // Store old heights before changing content
  const accordionHeights = [];
  activeAccordions.forEach(accordionItem => {
    const accordionHeader = accordionItem.querySelector('.accordion-header');
    const accordionContent = accordionHeader.nextElementSibling;

    if (accordionContent) {
      const currentMaxHeight = accordionContent.style.maxHeight ? parseInt(accordionContent.style.maxHeight) : accordionContent.scrollHeight;
      oldTotalHeight += currentMaxHeight;
      accordionHeights.push({ element: accordionContent, oldHeight: currentMaxHeight });
    }
  });

  // Update accordion content after 300ms delay
  // setTimeout(() => {
  accordionIds.forEach((accordionId) => {
    const metafieldSource = html.querySelector(accordionId);
    const metafieldDestination = document.querySelector(accordionId);
    if (metafieldSource && metafieldDestination) {
      metafieldDestination.innerHTML = metafieldSource.innerHTML;
    }
  });
  // }, 300);

  // Hide accordions with no content
  accordionIds.forEach((accordionId) => {
    const metafieldDestination = document.querySelector(accordionId);
    if (metafieldDestination) {
      const accordionItem = metafieldDestination.closest('.product-accordion-item');
  
      if (accordionItem) {
        const cleanedContent = metafieldDestination.innerHTML
          .replace(/<[^>]*>/g, '')
          .trim();
  
        if (!cleanedContent) {
          accordionItem.classList.add("d-none");
          accordionItem.classList.remove("active");
        } else {
          accordionItem.classList.remove("d-none");
        }
      }
    }
  });


  // Detect current variant label
  const variantLabelElement = html.querySelector('[data-initial-label]');
  let label = variantLabelElement ? variantLabelElement.getAttribute('data-initial-label') : '';
  label = label ? label.trim().toLowerCase() : '';
  
  // Certified Refurbished Terms
  const refurbAccordion = document.querySelector(`.product-accordion-body-Certified-Refurbished-Terms-${sectionId}`)?.closest('.product-accordion');
  if (refurbAccordion) {
    if (label === 'refurbished') {
      refurbAccordion.classList.remove('hidden', 'd-none');
    } else {
      refurbAccordion.classList.add('hidden', 'd-none');
      refurbAccordion.classList.remove('active');
    }
  }
  
  // B-Stock Terms
  const bstockAccordion = document.querySelector(`.product-accordion-body-B-Stock-Terms-${sectionId}`)?.closest('.product-accordion');
  if (bstockAccordion) {
    if (label === 'b-stock') {
      bstockAccordion.classList.remove('hidden', 'd-none');
    } else {
      bstockAccordion.classList.add('hidden', 'd-none');
      bstockAccordion.classList.remove('active');
    }
  }
  
  // Shipping & Returns
  const shippingAccordion = document.querySelector(`.product-accordion-body-Shipping-\\&-Returns-${sectionId}`)?.closest('.product-accordion');
  if (shippingAccordion) {
    const isDiscontinued = document.querySelector('[data-product-discontinued="true"]') ? true : false;
  
    if (label === 'refurbished' || label === 'b-stock' || isDiscontinued) {
      shippingAccordion.classList.add('hidden', 'd-none');
      shippingAccordion.classList.remove('active');
    } else {
      shippingAccordion.classList.remove('hidden', 'd-none');
    }
  }

  // Calculate new heights after content change and update maxHeight
  accordionHeights.forEach(({ element }) => {
    const newContentHeight = element.scrollHeight;
    newTotalHeight += newContentHeight;
    element.style.transition = `max-height 0ms ease`;
    element.style.maxHeight = newContentHeight + "px";
  });

  // Calculate height difference
  const heightDifference = newTotalHeight - oldTotalHeight;

  // Adjust left section height based on the difference
  if (heightDifference !== 0) {
    const currentLeftHeight = parseInt(leftSection.style.height) || leftSection.scrollHeight;
    leftSection.style.transition = `height 0ms ease`;
    if (isSticky) {
      leftSection.style.height = `${currentLeftHeight + heightDifference}px`;
    }
  }

  setTimeout(() => {
    leftSection.style.transition = `height 0ms ease`;
    accordionHeights.forEach(({element}) => {
      element.style.transition = `max-height 300ms ease`;
    });
  }, 300)

};

const openFirstProductAccordion = () => {
  const id = ".product-accordion";
  const accordions = document.querySelectorAll(id);
  if (accordions.length >= 0) {
    const firstAccordion = accordions[0];
    // Find the button inside the first accordion to simulate a click
    const accordionButton = firstAccordion?.querySelector(".accordion-button");
    if (accordionButton) {
      const isExpanded =
        accordionButton.getAttribute("aria-expanded") === "true";
      if (!isExpanded) {
        accordionButton.click();
      }
    }
  }
};


//sticky accordion
window.addEventListener("DOMContentLoaded", () => {
  const productAccordionButton = document.querySelectorAll(
    ".product-accordion-button"
  );
  productAccordionButton.forEach((button) => {
    button.addEventListener("click", function (event) {
      const isDesktop = window.innerWidth > 768;
      const rightSection = document.querySelector(
        ".product__info-container.product__column-sticky"
      );
      const leftSection = document.querySelector(".slider-mobile-gutter");
      const accordionItem = event.currentTarget.closest(
        ".product-accordion-item"
      );
      const accordionHeader = event.currentTarget.closest(".accordion-header");
      const accordionContent = accordionHeader.nextElementSibling;
      const isSticky =
        isDesktop && leftSection.scrollHeight >= rightSection.scrollHeight;
      accordionItem.classList.toggle("active");
      button.classList.toggle("collapsed");

      if (isSticky) {
        leftSection.style.height = `${leftSection.scrollHeight}px`;
      }

      if (accordionItem.classList.contains("active")) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        if (isSticky) {
          leftSection.style.transition = `height 300ms ease`;
          leftSection.style.height = `${leftSection.scrollHeight + accordionContent.scrollHeight
            }px`;
        }
      } else {
        accordionContent.style.maxHeight = 0;
        if (isSticky) {
          leftSection.style.transition = `height 300ms ease`;
          leftSection.style.height = `${leftSection.scrollHeight - accordionContent.scrollHeight
            }px`;
        }
      }
    });
  });
});

//when screen is resized then make left content height auto
window.addEventListener("resize", () => {
  const leftSection = document.querySelector(".slider-mobile-gutter");
  const isDesktop = window.innerWidth > 768;
  if (!isDesktop && leftSection) {
    leftSection.style.height = "auto";
  }
});

// after initial load complete
document.addEventListener("readystatechange", () => {
  if (document.readyState === "complete") {
    openFirstProductAccordion();
    loadImages();
  }
});

window.addEventListener("DOMContentLoaded", () => {
  checkAvailability();
  onVariantChangeAndOnLoad(null, true);
  updateProductBadge();
  checkSoldOut();
});

const openSearch=()=>{
  const urlParams = new URLSearchParams(window.location.search);
  const openSearch = urlParams.get("open_search");
  if (openSearch === "true") {
    if (window.innerWidth <= 768) {
      // Mobile
      const mobileSearchTrigger = document.querySelector("#mobile-search summary");
      if (mobileSearchTrigger) {
        mobileSearchTrigger.click();
      }
    } else {
      // Desktop
      const searchIcon = document.querySelector("#desktop-search summary");
      if (searchIcon) {
        searchIcon.click();
      }
    }
  }
}

const onLoad = () => {
  openSearch();
  checkAvailability();
  onVariantChangeAndOnLoad(null, true);
  checkSoldOut();

  //for those with the lazy Loading
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        updateProductBadge();
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};

window.onload = onLoad;